<template>
    <div class="pages memberData">
        <div class="f1 mb-30">
            <div class="title titles">
                <div class="txt">
                    <img src="../../assets/images/newIcon/vip_data_icon.png" alt="">
                    会员数据概览
                    <span>会员分级差异化运营，提升会员贡献度</span>
                </div>
                <div class="title" style="width:100%">
                    <div class="txt">
                    <span style="padding:0;">每天00:00:00更新1次，最新更新时间为：2021.10.10 00:00:00</span>
                    </div>
                    <div class="sx">
                    <el-radio-group v-model="tabPosition" style="margin-bottom: 30px;">
                            <el-radio-button label="1">昨日</el-radio-button>
                            <el-radio-button label="2">7天</el-radio-button>
                            <el-radio-button label="3">15天</el-radio-button>
                            <el-radio-button label="4">30天</el-radio-button>
                        </el-radio-group>
                        <el-date-picker
                            v-model="time1"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                </div>
            </div>
            <ul class="list">
                <li>
                   <div class="d1">
                       <img src="../../assets/images/newIcon/vip_vipnumber_icon.png" alt="">
                   </div>
                   <div class="d2">
                        <p>会员总数 
                            <el-tooltip class="item" effect="dark" content="会员总数为系统去重后所有渠道的会员数量，包含业务系统与导入" placement="right">
                            <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                            </el-tooltip>
                        </p>
                       <p>36,254 <span>环比前一日</span> <span>5.9% <i class="el-icon-top"></i></span></p>
                   </div>
                </li>
                <li>
                   <div class="d1">
                       <img src="../../assets/images/newIcon/vip_add_icon.png" alt="">
                   </div>
                   <div class="d2">
                       <p>新增会员 
                            <el-tooltip class="item" effect="dark" content="新增会员为业务系统中新增注册的新用户数据汇总。游客不计入此范围" placement="right">
                            <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                            </el-tooltip>
                        </p>
                       <p>36,254 <span>环比前一日</span> <span class="gru">5.9% 
                       <i class="el-icon-bottom "></i></span></p>
                   </div>
                </li>
                <li>
                   <div class="d1">
                       <img src="../../assets/images/newIcon/vip_use_icon.png" alt="">
                   </div>
                   <div class="d2">
                       <p>活跃用户 
                            <el-tooltip class="item" effect="dark" content="活跃用户指的是近期登陆应用的顾客数量汇总。可在会员中台设置活跃用户属性。" placement="right">
                            <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                            </el-tooltip>
                        </p>
                       <p>36,254 <span>环比前一日</span> <span class="gru">5.9% <i class="el-icon-bottom "></i></span></p>
                   </div>
                </li>
                <li>
                   <div class="d1">
                       <img src="../../assets/images/newIcon/vip_zhuanhua_icon.png" alt="">
                   </div>
                   <div class="d2">
                       <p>游客转化率 
                            <el-tooltip class="item" effect="dark" content="游客转化率=游客访问数/新客百分比。" placement="right">
                            <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                            </el-tooltip>
                        </p>
                       <p>36,254 <span>环比前一日</span> <span>5.9% <i class="el-icon-top"></i></span></p>
                   </div>
                </li>
            </ul>
        </div>
        <div class="f2 mb-30">
            <div class="title">
                <div class="txt">
                    <img src="../../assets/images/newIcon/vip_group_icon.png" alt="">
                    会员组
                    <span>系统内置的用户分组</span>
                </div>
            </div>
            <ul>
                <li>
                    <div class="d1">
                        <i></i>
                        新用户会员组
                        <el-tooltip class="item" effect="dark" content="近期x天内注册系统的新用户群体，快去设置运营计划留存新客户吧～" placement="right">
                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                        </el-tooltip>
                    </div>
                    <div class="d2">
                        <p>300 <span>同比上周</span><span class="red">5.9% <i class="el-icon-top"></i></span></p>
                        <p>更新时间：2020.10.10</p>
                    </div>
                    <div class="d3">
                        <p @click="groupDetail">
                            <img src="../../assets/images/newIcon/vip_groupcheck_icon.png" alt="">
                            查看详情
                        </p>
                        <p @click="goMarketing">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            去运营
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <i></i>
                        潜在会员组
                        <el-tooltip class="item" effect="dark" content="近期x天内注册但未消费的用户群体，可设置运营计划激活潜在客户。" placement="right">
                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                        </el-tooltip>
                    </div>
                    <div class="d2">
                        <p>300 <span>同比上周</span><span class="red">5.9% <i class="el-icon-top"></i></span></p>
                        <p>更新时间：2020.10.10</p>
                    </div>
                    <div class="d3">
                        <p @click="groupDetail">
                            <img src="../../assets/images/newIcon/vip_groupcheck_icon.png" alt="">
                            查看详情
                        </p>
                        <p @click="goMarketing">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            去运营
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <i></i>
                        消费会员组
                        <el-tooltip class="item" effect="dark" content="有过消费次数的用户群体数量汇总，可设置运营留存计划。" placement="right">
                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                        </el-tooltip>
                    </div>
                    <div class="d2">
                        <p>300 <span>同比上周</span><span class="red">5.9% <i class="el-icon-top"></i></span></p>
                        <p>更新时间：2020.10.10</p>
                    </div>
                    <div class="d3">
                        <p @click="groupDetail">
                            <img src="../../assets/images/newIcon/vip_groupcheck_icon.png" alt="">
                            查看详情
                        </p>
                        <p @click="goMarketing">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            去运营
                        </p>
                    </div>
                </li>
                <li>
                    <div class="d1">
                        <i></i>
                        忠实会员组
                        <el-tooltip class="item" effect="dark" content="消费次数超过x次的用户群体，属于品牌的高价值用户资产！" placement="right">
                        <img src="../../assets/images/newIcon/tishi_icon.png" alt="">
                        </el-tooltip>
                    </div>
                    <div class="d2">
                        <p>300 <span>同比上周</span><span class="red">5.9% <i class="el-icon-top"></i></span></p>
                        <p>更新时间：2020.10.10</p>
                    </div>
                    <div class="d3">
                        <p @click="groupDetail">
                            <img src="../../assets/images/newIcon/vip_groupcheck_icon.png" alt="">
                            查看详情
                        </p>
                        <p @click="goMarketing">
                            <img src="../../assets/images/newIcon/vip_groupjingying_icon.png" alt="">
                            去运营
                        </p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="f3">
            <ul>
                <li>
                    <div class="title">
                        <div class="txt">
                            <img src="../../assets/images/newIcon/vip_huaxiang_icon.png" alt="">
                            顾客标签画像
                            <span>展示应用次数最多的5个标签</span>
                        </div>
                    </div>
                        <el-table
                        :data="tableData"
                        :header-cell-style="{background:'#EEEEEE',textAlign: 'center'}"
                        style="width: 100%"
                        :cell-style="{padding:'15px 0px',fontSize:'12px',textAlign: 'center'}"
                        >
                        <el-table-column
                        prop="name"
                        label="标签"
                        show-overflow-tooltip
                       >

                        </el-table-column>

                        <el-table-column
                        prop="number"
                        label="应用人数"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="新用户"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="老用户"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="标签支付率"
                        >
                        </el-table-column>
                    </el-table>
                </li>
                <li class="l2">
                    <div>
                        <p>3000<span>个</span></p>
                        <p>标签总数</p>
                    </div>
                    <div>
                        <p>3000<span>个</span> </p>
                        <p>运营总数</p>
                    </div>
                    <div>
                        <p>3000<span>个</span></p>
                        <p>规则标签</p>
                    </div>
                </li>
                <li class="l3">
                    <div class="title">
                        <div class="txt">
                            <img src="../../assets/images/newIcon/vip_qudao_icon.png" alt="">
                            会员渠道占比
                            <span>渠道系统默认渠道与手动添加渠道</span>
                        </div>
                    </div>
                    <el-table
                        :data="tableData"
                       :header-cell-style="{background:'#EEEEEE',textAlign: 'center'}"
                        style="width: 100%"
                        :cell-style="{padding:'15px 0px',fontSize:'12px',textAlign: 'center'}"
                        >
                        <el-table-column
                        prop="name"
                        label="渠道"
                        show-overflow-tooltip
                        min-width="20%">

                        </el-table-column>

                        <el-table-column
                        prop="number"
                        label="渠道人数"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="xmember"
                        label="一周使用时长"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="lmember"
                        label="使用次数"
                        min-width="20%">
                        </el-table-column>
                        <el-table-column
                        prop="labellv"
                        label="次数留存率"
                        min-width="20%">
                        </el-table-column>
                    </el-table>
                </li>
            </ul>
            <ul class="u2">
                <li>
                    <div class="title">
                        <div class="txt">
                            <img src="../../assets/images/newIcon/vip_jixing_icon.png" alt="">
                            机型占比
                            <span>不同操作系统的数据分析</span>
                        </div>
                    </div>
                    <div id="c1"></div>
                </li>
                <li>
                    <div class="title">
                        <div class="txt">
                            <img src="../../assets/images/newIcon/vip_fangwen_icon.png" alt="">
                            访问行为概览
                            <span>近7天内用户的访问情况概览</span>
                        </div>
                    </div>
                    <div id="c2"></div>
                </li>
            </ul>
            <ul class="u3">
                <li>
                    <div class="title">
                        <div class="txt">
                            <img src="../../assets/images/newIcon/vip_ai_icon.png" alt="">
                            积木助手
                            <span>计算于：2021.07.18 - 2021.07.24</span>
                        </div>
                    </div>
                </li>
                <li class="li1" v-for="item in 2">
                    <div class="d1">
                        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                        <p>本周新增 <span>xxx</span> 位新用户，其中<span>xxx渠道</span>来源数量最多。同比上周增长 <span>12%</span>，快去激活会员吧</p>
                    </div>
                    <div class="d2">
                        <p>
                            <img src="../../assets/images/newIcon/vip_vipgroup_icon.png" alt="">
                            设为会员组
                        </p>
                        <p>
                            <img src="../../assets/images/newIcon/vip_vipjingying_icon.png" alt="">
                            会员经营
                        </p>
                        <p>
                            <img src="../../assets/images/newIcon/vip_aicheck_icon.png" alt="">
                            查看详情
                        </p>
                    </div>
                </li>
                <li v-for="item in 2" class="li1">
                    <div class="d1">
                        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                        <p>上上周新增会员的一周留存率为 <span>x%</span>，高于上次
                            <el-button type="text">查看详情 >></el-button>
                        </p>
                    </div>
                </li>
                <li class="li1" v-for="(item,index) in 2" :key="index">
                    <div class="d1">
                        <img src="../../assets/images/newIcon/ai_IP_icon.png" alt="">
                        <p>本周新增 <span>xxx</span> 位新用户，其中<span>xxx渠道</span>来源数量最多。同比上周增长 <span>12%</span>，快去激活会员吧</p>
                    </div>
                    <div class="d2">
                        <p>
                            <img src="../../assets/images/newIcon/vip_vipgroup_icon.png" alt="">
                            设为会员组
                        </p>
                        <p>
                            <img src="../../assets/images/newIcon/vip_huanxing_icon.png" alt="">
                            唤醒会员
                        </p>
                        <p>
                            <img src="../../assets/images/newIcon/vip_aicheck_icon.png" alt="">
                            查看详情
                        </p>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            tabPosition:"1",
            time1:"",
            tableData: [{
                name: '购买',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '重复',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '购买',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '购买',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
                }, {
                name: '购买',
                number:"3000",
                xmember:"200",
                lmember:"2700",
                labellv:"30%"
            }]
        }
    },
    mounted () {
        this.init();
        this.init2();
    },
    methods: {
         goNewMemberGroup(){
             this.$router.push({name:'newMemberGroup'})
        },
        goCrowdMarketing(){
             this.$router.push({name:'crowdMarketing'})
        },
        goCrowdDetails(){
            this.$router.push({name:'crowdDetails',query:{id:111}})
        },
        goScene(){
            this.$router.push({name:'sceneMarketing'});
        },
        groupDetail(){
            this.$router.push({name:"groupDetail",query:{id:111}})
        },
        goMarketing(){
            this.$router.push({name:"newMarketingPlan"})
        },
        init(){
            let data = [
            { item: 'iOS', count:36, percent: 0.36 },
            { item: '其他', count: 20, percent: 0.20 },
            { item: 'Android', count: 44, percent: 0.44 },
            // { item: '事例四', count: 13, percent: 0.13 },
            // { item: '事例五', count: 9, percent: 0.09 },
            ];

            let chart = new this.$chart({
            container: 'c1',
            autoFit: true,
            height: 345,
            
            });

            chart.data(data);

            chart.coordinate('theta', {
                radius: 0.65
            });

            chart.scale('percent', {
            formatter: (val) => {
                val = val * 100 + '%';
                // return val;
            },
            });
            chart.tooltip({
            showTitle: false,
            showMarkers: false,
            });
            chart.axis(false); // 关闭坐标轴
            const interval = chart
            .interval()
            .adjust('stack')
            .position('percent')
            .color('item',['#F84F52', '#B840F3', '#B6D2FF'])
            .label('percent', {
                offset: -40,
                style: {
                textAlign: 'center',
                shadowBlur: 2,
                shadowColor: 'rgba(0, 0, 0, .45)',
                fill: '#fff',
                },
            })
            .tooltip('item*percent', (item, percent) => {
                percent = percent * 100 + '%';
                return {
                name: item,
                value: percent,
                };
            })
            .style({
                lineWidth: 1,
                stroke: '#fff',
            });
            chart.interaction('element-single-selected');
            chart.render();

            // 默认选择
            // interval.elements[0].setState('selected', true);
        },
        init2(){
            let d1=[
                {data:"6.21",name:'日人均访问次数',val:1000},
                {data:"6.22",name:'日人均访问次数',val:200},
                {data:"6.23",name:'日人均访问次数',val:300},
                {data:"6.24",name:'日人均访问次数',val:400},
                {data:"6.25",name:'日人均访问次数',val:500},
                {data:"6.26",name:'日人均访问次数',val:800},
                {data:"6.27",name:'日人均访问次数',val:800},
            ]
            let d2=[
                {data:"6.21",name:'人数访问时长（分钟）',val:200},
                {data:"6.22",name:'人数访问时长（分钟）',val:400},
                {data:"6.23",name:'人数访问时长（分钟）',val:600},
                {data:"6.24",name:'人数访问时长（分钟）',val:200},
                {data:"6.25",name:'人数访问时长（分钟）',val:300},
                {data:"6.26",name:'人数访问时长（分钟）',val:500},
                {data:"6.27",name:'人数访问时长（分钟）',val:500},
            ]
            let d3=[
                {data:"6.21",name:'人均访问页面数',val:100},
                {data:"6.22",name:'人均访问页面数',val:300},
                {data:"6.23",name:'人均访问页面数',val:200},
                {data:"6.24",name:'人均访问页面数',val:500},
                {data:"6.25",name:'人均访问页面数',val:1000},
                {data:"6.26",name:'人均访问页面数',val:200},
                {data:"6.27",name:'人均访问页面数',val:300},
            ]
            let d4=[
                {data:"6.21",name:'月人均访问频次',val:300},
                {data:"6.22",name:'月人均访问频次',val:200},
                {data:"6.23",name:'月人均访问频次',val:100},
                {data:"6.24",name:'月人均访问频次',val:400},
                {data:"6.25",name:'月人均访问频次',val:100},
                {data:"6.26",name:'月人均访问频次',val:300},
                {data:"6.27",name:'月人均访问频次',val:200},
            ]
            let data=[...d1,...d2,...d3,...d4];

            const chart = new this.$chart({
            container: 'c2',
            autoFit: true,
            height: 310,
            padding:[40,20,100,40]
            });
            // chart
            // .interval({
            //     theme: {
            //     defaultColor: 'red',
            //     },
            // })
            // .position(0);
            chart.data(data);
            chart.scale({
            month: {
                range: [0, 1],
            },
            temperature: {
                nice: true,
            },
            });

            chart.tooltip({
            showCrosshairs: true,
            shared: true,
            });
            // chart.legend({
            //     'autoWrap':false
            // });
            chart.legend({
            //    layout:'vertical',
               flipPage:false, //图例不分页
               position:'bottom'
            });
            // chart.legend('autoWrap',false );
            chart.axis('val', {
            label: {
                formatter: (val) => {
                return val;
                },
            },
            });

            chart
            .line()
            .position('data*val')
            .color('name',["#5B8FF9","#5AD8A6",'#8956EC','#F6BD16'])
            .shape('smooth');

            // chart
            // .point()
            // .position('data*val')
            // .color('name')
            // .shape('circle');

            chart.render();
        }
    }
}
</script>
<style lang="less" scoped>
    @media screen and (min-width: 1200px) and (max-width: 1366px){
        .memberData .f1 .list li .d2 p:last-child{
                font-size: 18px !important;
        }
        .memberData .f2 ul li .d2 p:first-child{
            font-size:30px !important;
        }
        .memberData .f2 ul li .d2{
            padding:15px !important;
        }
        .memberData .f1 .list li{
            padding:12px !important;
        }
    }
    .memberData{
         .f1{
             /deep/ .el-radio-button--mini .el-radio-button__inner{
                 font-size:12px;
             }
             .list{
                 display: flex;
                 justify-content: space-between;
                 li{
                    width:24%;
                    box-sizing: border-box;
                     display: flex;
                    padding: 15px;
                    border-radius: 6px;
                     background: #fff;
                    .d1{
                        display: flex;
                        align-items: center;
                        margin-right:15px;
                        img{
                            width:44px;
                        }
                       
                         
                     }
                    .d2{
                        img{
                            width:16px;
                            vertical-align: middle;
                        }
                        p{
                            &:first-child{
                                margin-bottom:6px;
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(37, 49, 62, 0.85);
                            }
                            &:last-child{
                                font-size: 24px;
                                font-weight: bold;
                                color: #171E26;
                                span{
                                    font-size: 12px;
                                    font-weight: 400;
                                    color: #7E858C;
                                    padding-left: 6px;
                                    &:last-child{
                                        padding-left: 5px;
                                        font-weight: bold;
                                        color: #FF4343;
                                    }
                                }
                            }
                                
                        }
                    }
                 }
             }
         }
         .f2{
             ul{
                display: flex;
                justify-content: space-between;
                align-items: center;
                li{
                    box-sizing: border-box;
                    padding: 0 15px;
                    width:24%;
                    border-radius: 8px;
                    background: #fff;
                 .d1{
                    display: flex;
                    align-items: center;
                    padding:15px 15px 0 15px;
                     i{
                         margin-right:10px;
                        display: inline-block;
                        width: 4px;
                        height: 16px;
                        background: #3285F8;
                        border-radius: 3px;
                     }
                     font-size: 14px;
                    font-weight: 400;
                    color: rgba(37, 49, 62, 0.85);
                    img{
                        margin-left:10px;
                        width:16px;
                    }
                 }
                .d2{
                   padding:15px 30px;
                    p{
                        font-size: 43px;
                        font-weight: bold;
                        color: #000000;
                        span{
                            font-size: 12px;
                            font-weight: 400;
                            color: #666666;
                            &:last-child{
                                padding-left:10px;
                            }
                        }
                        &:last-child{
                            margin-top:10px;
                            font-size: 12px;
                            font-weight: 400;
                            color: #999999;
                        }
                    }
                 }
                .d3{
                    display: flex;
                
                    border-top:1px solid #EDEDED;
                    img{
                        width:16px;
                        vertical-align: middle;
                    }
                    p{
                        width:50%;
                        text-align: center;
                        padding:15px 0;
                    font-size: 12px;
                    font-weight: 400;
                    color: #3285F8;
                        &:first-child{
                            border-right:1px solid #ededed;
                        }
                    }
                }
                }
             }
         }
         .f3{
             display: flex;
             justify-content: space-between;
             ul{
                 width:29.3%;
                 &:first-child{
                     width:38%;
                 }
             }
             li{
                 margin-bottom:15px;
                 background: #fff;
                 border-radius: 8px;
                 /deep/ .el-table th>.cell{
                    font-size: 12px;
                    font-weight: 500;
                    color: #333333;
                 }
                 .title{
                     padding:15px 15px 0 15px;
                 }
                 
             }
             .l2{
                 display: flex;
                 padding:15px 0;
                 div{
                     border-right:1px solid #ededed;
                     width:33.3%;
                     text-align: center;
                     p{
                        font-size: 26px;
                        font-weight: bold;
                        color: #333333;
                        span{
                            font-size:12px !important;
                        }
                        &:last-child{
                            font-size: 12px;
                            font-weight: 400;
                            color: #333940;
                        }
                    }
                    &:last-child{
                        border:0px;
                    }
                 }
                //  justify-content: space-between;
             }
             .l3{
                 /deep/ .el-table th>.cell{
                     padding:0 6px;
                 }
             }
             .u2{
                 li{
                     padding:0px 15px;
                     padding-bottom:60px;
                     &:last-child{
                         padding-bottom:0px;
                     }
                 }
             }
             .u3{
                 li{
                     background: #f8f8f8;
                 }
                 .li1{
                      background: #fff;
                     .d1{
                         padding:15px;
                         display: flex;
                         align-items: center;
                         img{
                             width:60px;
                             margin-right:15px;
                         }
                         p{
                             font-size: 12px;
                            font-weight: 400;
                            color: #777777;
                            span{
                                font-size:14px;
                                color:#333333;
                            }
                         }
                     }
                     .d2{
                         display: flex;
                         
                         border-top:1px solid #ededed;
                         p{
                             padding:15px 0;
                             border-right:1px solid #ededed;
                            font-size: 12px;
                            font-weight: 400;
                            color: #3C3939;
                            width:33.3%;
                            text-align: center;
                            img{
                                width:16px;
                                vertical-align: middle;
                            }
                            &:last-child{
                                border:0px;
                            }
                         }
                         
                     }
                 }
             }
         }
         .titles{
             display:block !important;
             .title{
                 margin-top:15px;
                 .txt {
                     span{
                         color: #333333;
                     }
                 }
             }
         }
        .title{
                 display: flex;
                 justify-content: space-between;
                 margin-bottom:15px;
                 .txt{
                    font-size: 16px;
                    font-weight: 600;
                    color: #333940;
                     img{
                         width:20px;
                         vertical-align: middle;
                     }
                     span{
                         padding-left:15px;
                        font-size: 12px;
                        font-weight: 400;
                        color: #999999;
                     }
                 }
                 .sx{
                     display: flex;
                     align-items: center;
                     /deep/ .el-radio-button__inner, .el-radio-group{
                         margin:0 !important;
                         padding-right:15px;
                     }
                     /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner{
                         width:260px !important;
                     }
                     /deep/ .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                         background: #fff;
                         color:#327EFF;
                        //  border:1px solid #327EFF;
                     }
                 }
        }
    }
    .red{
        color:red !important;
    }
    .mb-30{
        margin-bottom:30px;
    }
    .mb-15{
        margin-bottom:15px;
    }
    .gru{
        color:#19E9AA !important;
    }
</style>